import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a5bfd81a73062d4efd66d74d8a70fdea9b from "./generated-d9bf779a-3f54-473e-8a9e-18859a2250ae.json";

import a5e00b7fc08b0dfed4494064c63da6aa2b from "./generated-edc9f7eb-331f-4eac-92f8-f827abd68b40.json";

import a3e275f50c2e16078255a590674cc5cf2b from "./generated-ff184f99-8991-4604-9a4e-97d95495039f.json";

import a0b41930311800f2e28450b953b994f8ab from "./generated-959a0f7f-da0b-42b8-98a3-901f58b0b14d.json";

import a41fae4ce221398ec8bdfd5d011e0ee27b from "./generated-bda9005d-4c68-4b1f-a3cb-145d6ec3d32a.json";

import a5073c5745096820e732956a1432103c2b from "./generated-453c0848-806b-4da3-9b51-50847b835665.json";

import a485806e795cdfea25baa7532144745d3b from "./generated-6ad300b6-a89d-444e-823c-077700ef620e.json";

import a822ac2e056ba39b995a60a3f86e1af41b from "./generated-e5ca5fc3-32c0-49aa-9f61-9c3a4948f083.json";

import a0b0a4a8d1d70cf709e207cae06a98316b from "./generated-c24aa96d-891c-4ab2-b3c4-1c4e1838929e.json";

import ab6f4b4bb29bf8a79b68a1df83888388eb from "./generated-492cbda1-905e-45b3-b64a-e69c112686c4.json";

import aae2b1f208d01220dd0a297d4f4f8481bb from "./generated-16de1070-c3db-42a9-9786-9bdd25242bbd.json";

import ace02e65a0e2f00bff3492085c3114518b from "./generated-08412ab5-8d59-4999-a5bb-2e496ac639b9.json";

import af12f31dea9caad6a91433e42ea65ca06b from "./generated-04e3e920-ff32-4106-862e-f06aaee522e4.json";

import a967c0be45f812db803d142663b6aaf19b from "./generated-6af7cdbc-03f9-4403-8eca-53ee10de8a67.json";

import a09e91040fdd2ec4e542c9c2cef98d925b from "./generated-d6fa6ed8-add9-4684-936e-1f75b7e1ad87.json";

import a8a08a378da1a8474beae442ac1c74f44b from "./generated-53ee871e-c124-4532-97a0-7ad060a23a2b.json";

import ad0967b756f7d7fff72f3ebcefc519c38b from "./generated-5de86844-8123-48ff-b4f6-55e1e0591adf.json";

import a855b8e4ab9d17d65ef68d400ace0b555b from "./generated-ea978534-cf7d-464b-a20f-3f74f959cdf3.json";

import a88f850c1fea3aba42dd401034adde822b from "./generated-1121572a-c819-4d8e-802e-b64fffff2355.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a5bfd81a73062d4efd66d74d8a70fdea9b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a5e00b7fc08b0dfed4494064c63da6aa2b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a3e275f50c2e16078255a590674cc5cf2b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a0b41930311800f2e28450b953b994f8ab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a41fae4ce221398ec8bdfd5d011e0ee27b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a5073c5745096820e732956a1432103c2b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a485806e795cdfea25baa7532144745d3b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a822ac2e056ba39b995a60a3f86e1af41b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a0b0a4a8d1d70cf709e207cae06a98316b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ab6f4b4bb29bf8a79b68a1df83888388eb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(aae2b1f208d01220dd0a297d4f4f8481bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ace02e65a0e2f00bff3492085c3114518b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(af12f31dea9caad6a91433e42ea65ca06b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a967c0be45f812db803d142663b6aaf19b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a09e91040fdd2ec4e542c9c2cef98d925b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a8a08a378da1a8474beae442ac1c74f44b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ad0967b756f7d7fff72f3ebcefc519c38b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a855b8e4ab9d17d65ef68d400ace0b555b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a88f850c1fea3aba42dd401034adde822b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ad0967b756f7d7fff72f3ebcefc519c38b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */